var map = {
	"./img-features-feature-2-game-1.png": "8p6e",
	"./img-features-feature-2-game-1@2x.png": "UKY0",
	"./img-features-feature-2-game-1@3x.png": "dZPy",
	"./img-features-feature-2-game-2.png": "WK74",
	"./img-features-feature-2-game-2@2x.png": "Fv/Z",
	"./img-features-feature-2-game-3.png": "ESN/",
	"./img-features-feature-2-game-3@2x.png": "e1wh",
	"./img-features-feature-2-game-3@3x.png": "xVpg",
	"./img-features-feature-2-game-4.png": "gEon",
	"./img-features-feature-2-game-4@2x.png": "FOl5",
	"./img-features-feature-2-game-4@3x.png": "Cao+",
	"./img-features-feature-2-game-5.png": "tQDD",
	"./img-features-feature-2-game-5@2x.png": "8FXr",
	"./img-features-feature-2-game-5@3x.png": "z9X1",
	"./img-features-feature-2-game-6.png": "NWf7",
	"./img-features-feature-2-game-6@2x.png": "iCGb",
	"./img-features-feature-2-game-6@3x.png": "2geS",
	"./img-features-feature-2-game-7.png": "/cn2",
	"./img-features-feature-2-game-7@2x.png": "ADv5",
	"./img-features-feature-2-game-7@3x.png": "fe+d",
	"./img-features-feature-2-game-8.png": "CafE",
	"./img-features-feature-2-game-8@2x.png": "jP7M",
	"./img-features-feature-2-game-8@3x.png": "QEh/"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ArDH";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features ^\.\/img\-features\-feature\-2\-game\-.*\.png$
// module id = ArDH
// module chunks = 18